import {
    CORE_GET_ALL_CAR_TYPE_REQUEST,
    CORE_GET_ALL_CAR_TYPE_SUCCESS,
    CORE_GET_ALL_CAR_TYPE_FAILURE,

    CORE_GET_MASTER_CAR_TYPE_REQUEST,
    CORE_GET_MASTER_CAR_TYPE_SUCCESS,
    CORE_GET_MASTER_CAR_TYPE_FAILURE,

    CORE_GET_CAR_TYPE_BY_ID_REQUEST,
    CORE_GET_CAR_TYPE_BY_ID_SUCCESS,
    CORE_GET_CAR_TYPE_BY_ID_FAILURE,



} from '../../carReservationType'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    carTypes: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_CAR_TYPE_REQUEST:
                return state
            case CORE_GET_ALL_CAR_TYPE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_CAR_TYPE_FAILURE:
                return []
            default:
                return state
        }
    },
    carType: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_CAR_TYPE_BY_ID_REQUEST:
                return state
            case CORE_GET_CAR_TYPE_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_CAR_TYPE_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    },
    masterCarType: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_MASTER_CAR_TYPE_REQUEST:
                return state
            case CORE_GET_MASTER_CAR_TYPE_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_MASTER_CAR_TYPE_FAILURE:
                return {}
            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/carReserve/carType.js